<div class="flex flex-col gap-4">
  <div class="border-b border-gray-200 pb-2">
    <h2 class="text-lg font-bold text-gray-900" i18n="@@viewRequestDetailsTitle">Request Details</h2>
  </div>

  <div class="grid grid-cols-3 gap-x-4 gap-y-6">
    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@requestDetailsId"># Request Id</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: data().requestId }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@requestDetailsStatus">Status</label>
      <div class="flex items-center gap-3">
        <app-status-badge
          [status]="data().currentStatus?.titleEn || 'pending'"
          [displayText]="getTranslatedTitle(data().currentStatus || { titleEn: 'Pending', titleAr: 'قيد الانتظار' })"
          size="sm"
          customClass="px-3 h-7 w-[130px]" />
      </div>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@requestDetailsAssignedTo">Assigned to</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: data().assignedTo?.fullName }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@requestDetailsCreatedOn">Created On</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: (data().createdOn | date) }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@requestDetailsLastModified">Last Modified On</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: (data().lastModifiedOn | date) }"></ng-container>
    </div>
  </div>

  <div class="mt-2 flex flex-col gap-1">
    <label class="text-primary text-xs font-bold" i18n="@@requestDetailsLastComment">Last comment</label>
    <div class="max-w-[75%] rounded-md border border-gray-100 bg-gray-50 p-3">
      <p class="text-sm leading-relaxed break-words text-gray-700">
        @if (data().comment) {
          {{ data().comment }}
        } @else {
          <ng-container i18n="@@noCommentsAvailable">No comments available.</ng-container>
        }
      </p>
    </div>
  </div>
</div>

<ng-template #displayVal let-val="val">
  @if (val) {
    <p class="text-sm text-gray-900">{{ val }}</p>
  } @else {
    <p class="text-sm font-medium text-gray-400" i18n="@@notAssigned">Not Assigned Yet</p>
  }
</ng-template>
